import { makeDefinitionFor } from '../../../helpers/endpoint.definition.details.generator';
import { generateValidationError, success } from '../../../shared/api.response.def';
import { department } from '../../../shared/department.def';

export const definition = makeDefinitionFor(
	'/department/{department_id}.json',
	{
		description: 'Get information on a single department',
		method: 'get',
		summary: 'Department Information',
		tags: ['Department'],
		params: [
			{
				$ref: '#/components/parameters/departmentIdPath',
			},
		],
	},
	[
		{
			code: 200,
			description: success,
			schema: department,
		},
		generateValidationError(),
	]
);
